"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var exceptions_1 = require("../exceptions");

var types_1 = require("./types"); // some promise wrappers around chrome tcp functions


var rejectIfFailure = function rejectIfFailure(code, resolve, reject) {
  if (code < types_1.TcpResult.Success) {
    reject(new exceptions_1.SocketError(messageForResultCode(code)));
  }

  resolve(code);
};

var tryChromeApi = function tryChromeApi(fn) {
  return function (resolve, reject) {
    try {
      fn(resolve);
    } catch (error) {
      reject(error);
    }
  };
};

exports.create = function (options) {
  if (options === void 0) {
    options = {};
  }

  return new Promise(tryChromeApi(function (resolve) {
    return chrome.sockets.tcp.create(options, function (createInfo) {
      return resolve(createInfo.socketId);
    });
  }));
};

exports.close = function (socketId) {
  return new Promise(tryChromeApi(function (resolve) {
    chrome.sockets.tcp.disconnect(socketId, resolve);
  }));
};

exports.connect = function (socketId, port, host) {
  return new Promise(function (resolve, reject) {
    chrome.sockets.tcp.connect(socketId, host, port, function (code) {
      rejectIfFailure(code, resolve, reject);
    });
  });
};

exports.write = function (socketId, data) {
  return new Promise(function (resolve, reject) {
    chrome.sockets.tcp.send(socketId, data, function (eventInfo) {
      rejectIfFailure(eventInfo.resultCode, resolve, reject);
    });
  });
};

function messageForResultCode(code) {
  switch (code) {
    case -23:
      return 'The socket is already connected.';

    case -100:
      return 'The connection was closed.';

    case -101:
      return 'The connection was reset.';

    case -102:
      return 'The connection attempt was refused.';

    case -103:
      return 'The connection timed out waiting for an acknowledgement.';

    case -104:
      return 'The connection attempt failed.';

    case -105:
      return 'The host name could not be resolved.';

    case -106:
      return 'The internet connection was lost.';

    case -108:
      return 'The provided host or port is invalid.';

    case -109:
      return 'The provided host is unreachable.';

    case -118:
      return 'The connection attempt timed out.';

    default:
      return 'Unknown socket error.';
  }
}

exports.messageForResultCode = messageForResultCode;